// Local store for the current outfit "in progress" — selections that carry across screens.
import { createContext, useContext, useState } from "react";

const OutfitDraftContext = createContext(null);

const initialDraft = {
  mode: null,           // upload | celebrity | budget
  imageBase64: null,    // user photo or inspiration photo
  imageMime: "image/jpeg",
  style: null,
  budget: "",
  height: "",
  weight: "",
  skinTone: "",
  gender: "",
  celebrity: "",
  appearance: null,     // { detected: {...}, recommendations: {...} } from /api/appearance/analyze
};

export function OutfitDraftProvider({ children }) {
  const [draft, setDraft] = useState(initialDraft);
  const update = (patch) => setDraft((d) => ({ ...d, ...patch }));
  const reset = () => setDraft(initialDraft);
  return (
    <OutfitDraftContext.Provider value={{ draft, update, reset }}>
      {children}
    </OutfitDraftContext.Provider>
  );
}

export function useOutfitDraft() {
  return useContext(OutfitDraftContext);
}
